module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921065649_T.af335a04.jpg";